/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FilterListsResponse } from '../models/filter-lists-response';
import { PaginatedApiResponseWithFilters } from '../models/paginated-api-response-with-filters';
import { ProfileResponse } from '../models/profile-response';

@Injectable({
  providedIn: 'root',
})
export class CustomerPlanningBoardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCustomerPlanningBoardList
   */
  static readonly GetCustomerPlanningBoardListPath = '/api/web/v1/customers/{customer}/planning-board';

  /**
   * Customer Planning Board — list booked profiles with embedded assignments and day-cells
   * for a [from, to] window.
   *
   * **Accessible to users with `FEATURE_ADMIN_ASSIGNMENTS` or `FEATURE_ADMIN_ASSIGNMENT_DATES`
   * on the customer.**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerPlanningBoardList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPlanningBoardList$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Window start (inclusive).
     */
    from: string;

    /**
     * Window end (inclusive). Must be on or after from; window must be at most 32 days.
     */
    to: string;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;

    /**
     * Search by profile.firstName, profile.lastName, profile.personalId. Max 100 chars.
     */
    search?: string;

    /**
     * Filter by Customer department ids; intersected with role scope (never widens). Embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'customerDepartments[]'?: any;

    /**
     * Filter by Customer location ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'customerLocations[]'?: any;

    /**
     * Filter by main Qualification ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'mainQualifications[]'?: any;

    /**
     * Filter by PSP Branch ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'pspBranches[]'?: any;
    orderKey?: 'lastName' | 'firstName' | 'plannedHours' | 'contractHours';
    orderDirection?: 'asc' | 'desc';
    context?: HttpContext
  }
): Observable<StrictHttpResponse<PaginatedApiResponseWithFilters & {
'data'?: Array<ProfileResponse>;
'filters'?: FilterListsResponse;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerPlanningBoardService.GetCustomerPlanningBoardListPath, 'get');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('search', params.search, {});
      rb.query('customerDepartments[]', params['customerDepartments[]'], {});
      rb.query('customerLocations[]', params['customerLocations[]'], {});
      rb.query('mainQualifications[]', params['mainQualifications[]'], {});
      rb.query('pspBranches[]', params['pspBranches[]'], {});
      rb.query('orderKey', params.orderKey, {});
      rb.query('orderDirection', params.orderDirection, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaginatedApiResponseWithFilters & {
        'data'?: Array<ProfileResponse>;
        'filters'?: FilterListsResponse;
        }>;
      })
    );
  }

  /**
   * Customer Planning Board — list booked profiles with embedded assignments and day-cells
   * for a [from, to] window.
   *
   * **Accessible to users with `FEATURE_ADMIN_ASSIGNMENTS` or `FEATURE_ADMIN_ASSIGNMENT_DATES`
   * on the customer.**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerPlanningBoardList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPlanningBoardList(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Window start (inclusive).
     */
    from: string;

    /**
     * Window end (inclusive). Must be on or after from; window must be at most 32 days.
     */
    to: string;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;

    /**
     * Search by profile.firstName, profile.lastName, profile.personalId. Max 100 chars.
     */
    search?: string;

    /**
     * Filter by Customer department ids; intersected with role scope (never widens). Embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'customerDepartments[]'?: any;

    /**
     * Filter by Customer location ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'customerLocations[]'?: any;

    /**
     * Filter by main Qualification ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'mainQualifications[]'?: any;

    /**
     * Filter by PSP Branch ids; embedded assignments[] is narrowed by this filter. Max 200 ids.
     */
    'pspBranches[]'?: any;
    orderKey?: 'lastName' | 'firstName' | 'plannedHours' | 'contractHours';
    orderDirection?: 'asc' | 'desc';
    context?: HttpContext
  }
): Observable<PaginatedApiResponseWithFilters & {
'data'?: Array<ProfileResponse>;
'filters'?: FilterListsResponse;
}> {

    return this.getCustomerPlanningBoardList$Response(params).pipe(
      map((r: StrictHttpResponse<PaginatedApiResponseWithFilters & {
'data'?: Array<ProfileResponse>;
'filters'?: FilterListsResponse;
}>) => r.body as PaginatedApiResponseWithFilters & {
'data'?: Array<ProfileResponse>;
'filters'?: FilterListsResponse;
})
    );
  }

}
